class CartDrawer extends HTMLElement {
  constructor() {
    super()

    this.header = document.querySelector(".header-wrapper")
    if (this.header) this.header.preventHide = false

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    )
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this, false)
    )
    this.setHeaderCartIconAccessibility()
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble")
    if (!cartLink) return
    cartLink.setAttribute("role", "button")
    cartLink.setAttribute("aria-haspopup", "dialog")
    cartLink.addEventListener("click", (event) => {
      event.preventDefault()
      if (!this.classList.contains("active")) {
        this.open(cartLink)
      } else {
        this.close()
      }
    })
  }

  open(triggeredBy) {
    if (this.header) {
      this.header.preventHide = true
      this.header.preventReveal = true
    }
    if (triggeredBy) this.setActiveElement(triggeredBy)

    const search = document.querySelector("header-search.header__search")
    if (search) search.close()

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary')
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) {
      this.setSummaryAccessibility(cartDrawerNote)
    }

    this.classList.add("active")

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer")
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close")
        trapFocus(containerToTrapFocusOn, focusElement)
      },
      { once: true }
    )

    document.body.classList.add("overflow-hidden-drawer")
  }

  close() {
    this.classList.remove("active")

    if (this.activeElement) {
      this.activeElement.focus()
    }

    document.body.classList.remove("overflow-hidden-drawer")

    if (this.header) {
      this.header.preventHide = false
      this.header.preventReveal = false
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button")
    cartDrawerNote.setAttribute("aria-expanded", "false")

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      )
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      )
    })

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape)
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty")
    this.productId = parsedState.id
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id)
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      )
    })

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this, false)
      )
      this.open()
      if (
        document.querySelector("cart-popular-products-slider") &&
        typeof document.querySelector("cart-popular-products-slider").init ===
          "function"
      ) {
        document.querySelector("cart-popular-products-slider").init()
      }
    })
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ]
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector)
  }

  setActiveElement(element) {
    this.activeElement = element
  }
}

customElements.define("cart-drawer", CartDrawer)

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ]
  }
}

customElements.define("cart-drawer-items", CartDrawerItems)
